<template>

	<div class="knd-gridkaart-wrapper">



		<!-- knopjes -->
		<div class="knd-select-cats-wrapper">
			<div
				v-show="this.interaction" 
				class="knd-select-cats"
				lang="nl">

				<div 
					v-for="cat in categories" 
					:key="cat.label"
					class="knd-select-cat"
					@click="setCategory(cat)">

					<div 
						class="knd-select-text">
						{{ cat.tekst }}
					</div>

					<div :class="[{active: isCategory(cat)}, 'knd-icon-wrapper']">
						<img 
							:src="require('@/assets/icons/' + cat.icon[0])"
							:class='"knd-select-icon " + cat.label' />
					</div>

					<div 
						class="knd-select-text bottom">
						{{ getPercentage(cat) }}%
					</div>

					<!-- <div 
						v-if="predraw === true && interaction === true && cat.nieuw !== null"
						class="knd-select-text doel">
						Doel overheid: {{ cat.nieuw }}%
					</div> -->
				</div>

			</div>	
		</div>

		<div v-if="this.interaction" class="knd-swipe-pijl-wrapper links">
			<img 
				v-if="this.interaction" 
				:src="require('@/assets/icons/pijl.svg')" 
				class="knd-swipe-pijl links" />
		</div>

		<div v-if="this.interaction" class="knd-swipe-pijl-wrapper rechts">
			<img 
				v-if="this.interaction" 
				:src="require('@/assets/icons/pijl.svg')" 
				class="knd-swipe-pijl rechts" />
		</div>
			
		<!-- gridkaart -->

		<div class="bol-rood-wrapper bol-3">
			<div class="bol-rood"></div>
		</div>
		<div class="knd-gridkaart" ref="gridkaart">
			<div v-if="this.interaction" class="knd-message-drag">Selecteer een categorie en veeg over de kaart om te tekenen.</div>
		</div>

		<div 
			v-if="predraw === false && interaction === true" 
			class="knd-button kaart"
			@click="SVGtoImg()"
			v-html="buttonText()"></div>
		<canvas ref="tempcanvas"></canvas>

	</div>
</template>

<script>
	import Gridkaart from './gridkaart';
	import './gridkaart.scss';
	// import cats from './../../assets/data/cats.json';

	export default {
		name: 'Hexkaart',
		props: ['interaction', 'predraw', 'annotation'],
		data: function() {
			return {
				maps: this.$store.state.map,
				categories: this.$store.state.categories,
				curr_cat: null,
				mobiel: null
			}
		},
		methods: {
			updateCategories(categories) {
				this.categories = categories;
				this.$store.dispatch('updateCategories', categories);
			},

			isCategory(cat) {
				return cat === this.curr_cat;
			},

			setCategory(cat) {
				this.kaart.setCategory(cat);
				this.curr_cat = cat;
			},

			getPercentage(cat) {
				if (this.interaction === true && this.predraw === true) {
					return Math.round(cat.edit_perc * 10) / 10;
				}
				else if (this.interaction === true) {
					return Math.round(cat.user_perc * 10) / 10;
				}
				else { 
					return Math.round(cat.perc * 10) / 10;
				}
			},

			buttonText() {
				if (navigator.canShare) {
					return "Tevreden? Deel hier jouw Nederland";
				}
				else {
					return "Tevreden? Download hier een plaatje van jouw Nederland";
				}
			},

			triggerDownload(imgURI) {
				var evt = new MouseEvent('click', {
					view: window,
					bubbles: false,
					cancelable: true
				});

				var a = document.createElement('a');
				a.setAttribute('download', 'Pointer-Gevecht_om_de_grond.png');
				a.setAttribute('href', imgURI);
				a.setAttribute('target', '_blank');

				a.dispatchEvent(evt);
			},

			dataURLtoFile(dataurl, filename) {
				var arr = dataurl.split(","),
					mimeType = arr[0].match(/:(.*?);/)[1],
					decodedData = atob(arr[1]),
					lengthOfDecodedData = decodedData.length,
					u8array = new Uint8Array(lengthOfDecodedData);

				while (lengthOfDecodedData--) {
					u8array[lengthOfDecodedData] = decodedData.charCodeAt(lengthOfDecodedData);
				}

				return new File([u8array], filename, { type: mimeType });
			},

			shareFile(file, title, text) {
				if (navigator.canShare && navigator.canShare({ files: [file] })) {
					navigator
						.share({
							files: [file],
							title,
							text
						})
						.then(() => console.log("Share was successful."))
						.catch((error) => console.log("Sharing failed", error));
				} else {
					console.log(`Your system doesn't support sharing files.`);
				}
			},

			shareImage(dataUrl) {
				const file = this.dataURLtoFile(dataUrl, "NLGrondgebruik.png");
				this.shareFile(file, "Mijn verdeling van Nederland", "Ik heb een indeling gemaakt van Nederland #pointergevechtomdegrond");
			},

			SVGtoImg() {
				console.log("downloadSVG");

				const svg = this.$refs.gridkaart.querySelector("svg");
				const canvas = this.$refs.tempcanvas;
				canvas.width = 600;
				canvas.height = 400;

				var ctx = canvas.getContext('2d');
				var data = (new XMLSerializer()).serializeToString(svg);
				var DOMURL = window.URL || window.webkitURL || window;

				var img = new Image();
				var svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});
				var url = DOMURL.createObjectURL(svgBlob);

				img.onload = () => {
					//isometrisch
					ctx.scale(1, 0.5);
					ctx.rotate(-45 * Math.PI /180);

					if (window.innerWidth < 500) {
						ctx.drawImage(img, -400, 300);
					}
					else {
						ctx.drawImage(img, -400, 100);
					}

					DOMURL.revokeObjectURL(url);

					var imgURI = canvas
							.toDataURL('image/png')
							.replace('image/png', 'image/octet-stream');

					if (navigator.canShare) {
						this.shareImage(imgURI);
					}
					else {
						this.triggerDownload(imgURI);
					}
					
				};

				img.src = url;
			},

			checkMobiel() {
				const windowWidth = window.innerWidth;

				if (windowWidth < 500) {
					this.mobiel = true;
				}
			}
		},
		mounted: function() {
			this.kaart = new Gridkaart()
				.setdrawIcons()
				.container(this.$refs.gridkaart)
				.interaction(this.interaction)
				.predraw(this.predraw)
				.annotation(this.annotation)
				.setCategory("agrarisch")
				.categories(this.categories)
				.grid(this.maps)
				.callBacks({"updateCategories": this.updateCategories})
				.render();

			//zodat het grafiekje meteen goed gaat staan
			this.updateCategories(this.categories);

			//mobiel check
			window.addEventListener('resize', this.checkMobiel);
			this.checkMobiel();
		},
		watch: {
			categories: {
				handler(newVal, oldVal) {
					this.kaart.updateAnnotaties();
				},
				deep: true
			}
		}
	}
</script>